import React, { Component } from 'react'

export default class CloseIcon extends Component{
	render(){
		return(
            <i
                className="material-icons"
                style={{
                    cursor: "pointer"
                  , display: "inline-block"
                  , fontSize: "28px"
                  , marginLeft:"12px"
                  , color: "#FFF"
                  , marginTop: "16px"
                }}
            >
                arrow_back
            </i>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/icons/BackIcon.js